import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/Headers/PageHeader";
import PageMain from "../../../components/Main/PageMain";
import useFetch from "../../../hooks/useFetch";
// import * as api from "../../../constants/api";
import Spinner from "../../../components/Spinner";
// import { useNavigate } from "react-router";
// import * as r from "../../../constants/routes";
import classes from "./FiltersDashboard.module.scss";
import SessionContext from "../../../context/sessionContext";
import CardBlue from "../../../components/CardFiltersDashboard/CardBlue";
import CardWhite from "../../../components/CardFiltersDashboard/CardWhite";
import dashboard01 from "./../../../assets/images/dashboard_images/img_dash_01.svg";
import dashboard02 from "./../../../assets/images/dashboard_images/img_dash_02.svg";
import dashboard03 from "./../../../assets/images/dashboard_images/img_dash_03.svg";
import dashboard04 from "./../../../assets/images/dashboard_images/img_dash_04.svg";
import dashboard05 from "./../../../assets/images/dashboard_images/img_dash_05.svg";
import dashboard06 from "./../../../assets/images/dashboard_images/img_dash_06.svg";
import dashboard07 from "./../../../assets/images/dashboard_images/img_dash_07.svg";
import dashboard08 from "./../../../assets/images/dashboard_images/img_dash_08.svg";
import * as a from "../../../constants/api";
import moment from "moment";
import ModalUsersFiltered from "../../../components/CardFiltersDashboard/ModalUsersFiltered";
import FiltersArea from "../../../components/CardFiltersDashboard/FiltersArea";

export default function FiltersDashboard() {
  const { t } = useTranslation();
  const cSessions = useContext(SessionContext);
  const [open, setOpen] = useState(false);
  const [openCountPlay, setOpenCountPlay] = useState(false);
  const [indexCardWhite, setIndexCardWhite] = useState();
  const [indexCardBlue, setIndexCardBlue] = useState();
  const [usersShowWhite, setUsersShowWhite] = useState<number[]>([]);
  const [usersShowBlue, setUsersShowBlue] = useState<number[]>([]);
  const [listUser, , , listUserFetch]: any = useFetch({
    autoInit: false,
  });
  const [groupsInfos, , , groupsInfosFetch]: any = useFetch({
    autoInit: false,
  });
  // const [selectedOption, setSelectedOption] = useState("");
  const [listUserFiltered, setListUserFiltered] = useState(listUser);
  const [cardWhiteObj, setCardWhiteObj] = useState<
    Array<{
      title: string;
      img: any;
      number: number;
      numberDesc: any;
      showInfo: string;
    }>
  >([]);
  const [cardBlueObj, setCardBlueObj] = useState<
    Array<{ title: string; desc: string; number: number }>
  >([]);
  const [content, setContent] = useState(<Spinner center />);
  const [userJourney, setUserJourney] = useState({
    preRegistration: 0,
    registered: 0,
    avaliation: 0,
    training: 0,
    trainingExpired: 0,
    trainingWithoutPlays: 0,
    reAvaliation: 0,
    reAvaliationWithoutPlay: 0,
    endJourney: 0,
    endJourneyWithoutPlays: 0,
    averagePlays: 0,
    groupeNumber: 0,
  });

  // const data = moment(dataString);

  // Obter a data atual
  const dataAtual = moment();

  // // Verificar se a data é maior que a data atual
  // const isDataMaiorQueAtual = moment(dataString).isAfter(dataAtual);

  useEffect(() => {
    listUserFetch({ url: a.API_USERS_ALL_SMART });
    groupsInfosFetch({ url: a.API_USERS_GROUPS_AUDIOFOCO(cSessions.company_uid) });
  }, [listUserFetch]);

  useEffect(() => {
    setListUserFiltered(listUser);
  }, [listUser]);

  useEffect(() => {
    setUserJourney((prevState) => ({
      ...prevState,
      preRegistration:
        listUserFiltered &&
        listUserFiltered.filter((user: any) => user.journey_code === -2).length,
      registered:
        listUserFiltered &&
        listUserFiltered.filter((user: any) => user.journey_code === -1).length,
      avaliation:
        listUserFiltered &&
        listUserFiltered.filter((user: any) => user.journey_code === 0).length,
      training:
        listUserFiltered &&
        listUserFiltered.filter((user: any) => user.journey_code === 1).length,
      trainingExpired:
        listUserFiltered &&
        listUserFiltered.filter(
          (user: any) =>
            user.journey_code === 1 &&
            moment(user.date_IA_finish).isAfter(dataAtual)
        ).length,
      trainingWithoutPlays:
        listUserFiltered &&
        listUserFiltered.filter(
          (user: any) => user.journey_code === 1 && user.amt_plays === 0
        ).length,
      reAvaliation:
        listUserFiltered &&
        listUserFiltered.filter((user: any) => user.journey_code === 2).length,
      reAvaliationWithoutPlay:
        listUserFiltered &&
        listUserFiltered.filter(
          (user: any) => user.journey_code === 2 && user.amt_plays === 0
        ).length,
      endJourney:
        listUserFiltered &&
        listUserFiltered.filter((user: any) => user.journey_code === 3).length,
      endJourneyWithoutPlays:
        listUserFiltered &&
        listUserFiltered.filter(
          (user: any) => user.journey_code === 3 && user.amt_plays === 0
        ).length,
      averagePlays:
        listUserFiltered &&
        listUserFiltered.length > 0 &&
        (
          listUserFiltered.reduce((total: any, objeto: any) => {
            return total + objeto.amt_plays;
          }, 0) / listUserFiltered.length
        ).toFixed(1),
      groupeNumber: groupsInfos
        ? groupsInfos.filter((g: any) => g.status === "active").length
        : 0,
    }));
    setUsersShowWhite(
      listUserFiltered && [
        listUserFiltered.filter((user: any) => user.journey_code === 0),
        listUserFiltered.filter((user: any) => user.journey_code === 1),
        listUserFiltered.filter(
          (user: any) =>
            user.journey_code === 1 &&
            moment(user.date_IA_finish).isAfter(dataAtual)
        ),
        listUserFiltered.filter((user: any) => user.journey_code === 2),
        listUserFiltered.filter(
          (user: any) => user.journey_code === 2 && user.amt_plays === 0
        ),
        listUserFiltered.filter((user: any) => user.journey_code === 3),
        (
          listUserFiltered.reduce((total: any, objeto: any) => {
            return total + objeto.amt_plays;
          }, 0) / listUserFiltered
        ).toFixed(1),
        Object.keys(
          listUserFiltered.reduce((acc: any, obj: any) => {
            if (obj.group_name !== null && obj.group_name !== "") {
              acc[obj.group_name] = true;
            }
            return acc;
          }, {})
        ),
      ]
    );
    setUsersShowBlue(
      listUserFiltered && [
        listUserFiltered.filter((user: any) => user.journey_code === -2),
        listUserFiltered.filter((user: any) => user.journey_code === -1),
        listUserFiltered.filter(
          (user: any) => user.journey_code === 1 && user.amt_plays === 0
        ),
        listUserFiltered.filter(
          (user: any) => user.journey_code === 3 && user.amt_plays === 0
        ),
      ]
    );
  }, [listUserFiltered]);

  useEffect(() => {
    setCardWhiteObj([
      {
        title: t("filters.first_avaliation_ongoing"),
        img: dashboard01,
        number: userJourney.avaliation ?? 0,
        numberDesc: "usuários",
        showInfo: "ver usuários",
      },
      {
        title: t("filters.training"),
        img: dashboard02,
        number: userJourney.training ?? 0,
        numberDesc: "usuários",
        showInfo: "ver usuários",
      },
      {
        title: t("filters.end_training_without_reavaliation"),
        img: dashboard03,
        number: userJourney.trainingExpired ?? 0,
        numberDesc: "usuários",
        showInfo: "ver usuários",
      },
      {
        title: t("filters.in_reavaliation"),
        img: dashboard04,
        number: userJourney.reAvaliation ?? 0,
        numberDesc: "usuários",
        showInfo: "ver usuários",
      },
      {
        title: t("filters.in_reavaliation_without_play"),
        img: dashboard05,
        number: userJourney.reAvaliationWithoutPlay ?? 0,
        numberDesc: "usuários",
        showInfo: "ver usuários",
      },
      {
        title: t("filters.end_journey"),
        img: dashboard06,
        number: userJourney.endJourney ?? 0,
        numberDesc: "usuários",
        showInfo: "ver usuários",
      },
      {
        title: t("filters.plays_avarage"),
        img: dashboard07,
        number: userJourney.averagePlays > 0 ? userJourney.averagePlays : 0,
        numberDesc: "por usuário",
        showInfo: "ver detalhes",
      },
      {
        title: t("filters.qnt_groups"),
        img: dashboard08,
        number: userJourney.groupeNumber ?? 0,
        numberDesc: "",
        showInfo: "",
      },
    ]);
    setCardBlueObj([
      {
        title: t("filters.do_not_access"),
        desc: t("filters.who_never_access"),
        number: userJourney.preRegistration ?? 0,
      },
      {
        title: t("filters.never_access_and_no_tests"),
        desc: t("filters.login_and_not_iniciate"),
        number: userJourney.registered ?? 0,
      },
      {
        title: t("filters.no_plays_no_training"),
        desc: t("filters.who_never_play"),
        number: userJourney.trainingWithoutPlays ?? 0,
      },
      {
        title: t("filters.journey_end_without_play"),
        desc: t("filters.journey_end_without_play_explanation"),
        number: userJourney.endJourneyWithoutPlays ?? 0,
      },
    ]);
  }, [userJourney]);

  useEffect(() => {
    if (indexCardWhite === 7) {
      setOpen(false);
    }
  }, [indexCardWhite, open]);

  useEffect(() => {
    setContent(
      <div>
        <ModalUsersFiltered
          open={open}
          setOpen={setOpen}
          usersShowWhite={usersShowWhite}
          indexCardWhite={indexCardWhite}
          usersShowBlue={usersShowBlue}
          indexCardBlue={indexCardBlue}
          listUserFiltered={listUserFiltered}
          cardBlueObj={cardBlueObj}
          cardWhiteObj={cardWhiteObj}
        />
        <FiltersArea
          listUserFiltered={listUserFiltered}
          listUser={listUser || []}
          optionsGroups={groupsInfos}
          setListUserFiltered={setListUserFiltered}
        />
        <div className={classes.CardWhiteArea}>
          {(cardWhiteObj || []).map((filter, index: any) => (
            <CardWhite
              key={index}
              title={filter.title}
              img={filter.img}
              number={filter.number}
              numberDesc={filter.numberDesc}
              showInfo={filter.showInfo}
              open={open}
              setOpen={setOpen}
              setIndexCardWhite={setIndexCardWhite}
              setIndexCardBlue={setIndexCardBlue}
              setOpenCountPlay={setOpenCountPlay}
              openCountPlay={openCountPlay}
              index={index}
              indexCardWhite={indexCardWhite}
            />
          ))}
        </div>
        <div className={classes.CardBlueArea}>
          {(cardBlueObj || []).map((filter, index) => (
            <CardBlue
              key={index}
              title={filter.title}
              desc={filter.desc}
              number={filter.number}
              open={open}
              setOpen={setOpen}
              setIndexCardWhite={setIndexCardWhite}
              setIndexCardBlue={setIndexCardBlue}
              index={index}
            />
          ))}
        </div>
      </div>
    );
  }, [cardWhiteObj, cardBlueObj, open, groupsInfos]);
  return (
    <>
      <PageHeader title={t("Painel Geral")} />
      <PageMain center>
        <>{content}</>
      </PageMain>
    </>
  );
}
